import "bootstrap/dist/css/bootstrap.min.css";
import "./Css/main.css";
import PageWrap from "./View/PageWrap";

import { ProtectedRoute } from "./Share/ProtectedRoute"; // chứng thực token

import {
  subUrl,
  adminHome,
  subUrlAdmin,
  login,
  signup,
  accuracy,
  rePass,
  changePass,
  manualdownload,
  adminLogin,
  adminNews,
  adminCreateNew,
  adminUpdateNews,
  clientNewsDetail,
  clientNewsDocument,
  adminUser,
  adminVerify,
  adminHistory,
  // clientPayment,
  clientHome,
  adminVoucher,
  adminVoucherHistory,
  clientTransaction,
  adminRateLimit,
  recoverDetail,
  adminChat,
  adminItemUsage,
  adminTopUp,
} from "./Api/SubUrl";

import {
  AdminPage,
  AdminDashboard,
  AdminLogin,
  AdminNews,
  AdminCreateNew,
  AdminUpdateNew,
  AdminVoucher,
  AdminUser,
  AdminHistory,
  AdminVoucherHistory,
  VerifyPage,
  AdminRateLimit,
  AdminChat,
  AdminItemUsage,
  AdminTopUp,
} from "./View/Admin";

import {
  ClntPage,
  ClnAccuracy,
  ClnRePassword,
  ClnChangPass,
  ClnDownloadGame,
  ClnNewDetail,
  ClnNewDocument,
  ClientPayment,
  ClientTransaction,
  RecoverDetailPage,
} from "./View/Client";
import Login from "./View/Login";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css"; // Import file CSS của "aos"
import "rsuite/dist/rsuite.min.css";
import Signup from "./View/Client/SignUp";
import UpdateProfile from "./View/Client/UpdateProfile";
import { clientUpdateProfile } from "./Api/SubUrl";
import ClientProtectedRoute from "./Share/ClientProtectedRoute";
// Khởi tạo "aos" với các tùy chọn (nếu cần)
AOS.init({
  duration: 1000, // Thời gian thực hiện hiệu ứng (mặc định là 1000ms)
  easing: "ease-in-out", // Kiểu easing (mặc định là 'ease')
});

function App() {
  AOS.init();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PageWrap />}>
          {/* admin */}

          <Route
            path={subUrlAdmin}
            element={
              <ProtectedRoute>
                <AdminPage />
              </ProtectedRoute>
            }
          >
            <Route path={adminHome} element={<AdminDashboard />} />
            <Route path={adminNews} element={<AdminNews />} />
            <Route path={adminCreateNew} element={<AdminCreateNew />} />
            <Route path={adminUpdateNews} element={<AdminUpdateNew />} />
            <Route path={adminUser} element={<AdminUser />} />
            <Route path={adminHistory} element={<AdminHistory />} />
            <Route path={adminVoucher} element={<AdminVoucher />} />
            <Route path={adminRateLimit} element={<AdminRateLimit />} />
            <Route path={adminChat} element={<AdminChat />} />
            <Route path={adminItemUsage} element={<AdminItemUsage />} />
            <Route path={adminTopUp} element={<AdminTopUp />} />
            <Route
              path={adminVoucherHistory}
              element={<AdminVoucherHistory />}
            />
          </Route>
          <Route path={adminLogin} element={<AdminLogin />} />
          <Route path={adminVerify} element={<VerifyPage />} />

          {/* Client */}
          <Route
            path={subUrl}
            element={
              <ClientProtectedRoute>
                <ClntPage />
              </ClientProtectedRoute>
            }
          >
            <Route path={subUrl} element={<Navigate to={login} replace />} />
            <Route path={clientHome} element={<Navigate to={login} replace />} />
            <Route path={accuracy} element={<ClnAccuracy />} />
            <Route path={rePass} element={<ClnRePassword />} />
            <Route path={changePass} element={<ClnChangPass />} />
            {/* <Route path={manualdownload} element={<ClnDownloadGame />} /> */}
            <Route path={login} element={<Login />} />
            <Route path={signup} element={<Signup />} />
            <Route path={clientUpdateProfile} element={<UpdateProfile />} />
            {/* <Route path={recoverDetail} element={<RecoverDetailPage />} /> */}
          </Route>
          <Route
            element={
              <ClientProtectedRoute>
                <ClntPage />
              </ClientProtectedRoute>
            }
          >
            {/* <Route path={clientNewsDocument} element={<ClnNewDocument />} /> */}
            {/* <Route path={clientNewsDetail} element={<ClnNewDetail />} /> */}
            <Route path={clientTransaction} element={<ClientTransaction />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
